import { TPAComponentProps, RequiredProps, LangProps } from '../../types';
import { ErrorMessageWrapperProps } from '../internal/ErrorMessageWrapper';
import { Placement } from '../internal/WixUiCoreComponents/components/CorePopover';

export enum TextAreaTheme {
  Box = 'box',
  Line = 'line',
}

export interface TextAreaProps
  extends TPAComponentProps,
    RequiredProps,
    LangProps {
  value: string;
  id?: string;
  error?: boolean;
  success?: boolean;
  ariaLabel: string;
  disabled?: boolean;
  placeholder?: string;
  /** Adds the label element associated with the textarea element. */
  label?: string;
  /** Possible values: 'line', 'box' */
  theme?: TextAreaTheme;
  /** the error message to display */
  errorMessage?: string;
  /** Appearance of error message. TextOnly | BackgroundAndBorder */
  errorAppearance?: ErrorMessageWrapperProps['errorAppearance'];
  /** the error message to display - deprecated. Use `errorMessage` instead */
  errorDescription?: string;
  /** error tooltip max width */
  errorTooltipMaxWidth?: number;
  /** Placement for Popover. Optional. */
  errorTooltipPlacement?: Placement;
  /** Specifies whether to apply the new design and behavior of error messages */
  newErrorMessage?: boolean;
  autoFocus?: boolean;
  onChange(event: React.ChangeEvent<HTMLTextAreaElement>): void;
  onBlur?(event: React.FocusEvent<HTMLTextAreaElement>): void;
  onFocus?(event: React.FocusEvent<HTMLTextAreaElement>): void;
  maxLength?: number;
  /** Whether to display the character count. In order to show the charCount you must pass the maxLength prop. Optional. */
  showCharCount?: boolean;
  'aria-describedby'?: string;
  /** Add resize functionality for the TextArea */
  withResize?: boolean;
  rows?: number;
}

export interface TextAreaDefaultProps {
  error: boolean;
  success: boolean;
  disabled: boolean;
  placeholder: string;
  theme: TextAreaTheme;
  errorMessage: string;
  errorDescription: string;
  showCharCount: boolean;
  errorTooltipPlacement: Placement;
  withResize: boolean;
  required: boolean;
}

export interface TextAreaState {
  focused: boolean;
  isErrorTooltipShown: boolean;
}
